import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4916a264"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tr" }
const _hoisted_2 = { class: "td rowhead" }
const _hoisted_3 = { class: "td choice all-choice" }

import { computed, PropType } from "vue";
import { useI18n } from "vue-i18n";
import { get } from "lodash-es";
import VueCheckbox from "../components/Checkbox.vue";
import {
  CommunicatieMedium,
  communicatieMedia,
  OptInKeuze,
  PermissieViewModel,
} from "../TypeScriptModels";

type CheckboxStatus = {
  isAllJa: boolean;
  isAllNee: boolean;
  isAllUnknown: boolean;
  isIndeterminate: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'Permissie',
  props: {
  label: {
    type: String,
    default: "",
  },
  permissie: {
    type: Object as PropType<PermissieViewModel>,
    default: null,
  },
  permissieKey: {
    type: String,
    required: false,
    default: "",
  },
  isTotal: {
    type: Boolean,
    required: false,
    default: false,
  },
  mediumStatuses: {
    type: Object as PropType<Record<string, CheckboxStatus>>,
    default: () => ({}),
  },
  allStatus: {
    type: Object as PropType<CheckboxStatus>,
    default: () => ({
      isAllJa: false,
      isAllNee: false,
      isAllUnknown: true,
      isIndeterminate: false,
    }),
  },
},
  emits: ["click", "allclick", "rowclick", "allrowclick"],
  setup(__props, { emit }: { emit: ({
  (
    e: "click",
    data: {
      permissie: string;
      field: string;
    }
  ): void;
  (
    e: "allclick",
    data: {
      medium: string;
      value: boolean;
    }
  ): void;
  (
    e: "rowclick",
    data: {
      permissie: string;
      value: boolean;
    }
  ): void;
  (
    e: "allrowclick",
    data: {
      value: boolean;
    }
  ): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props

function emptyStatus(): CheckboxStatus {
  return {
    isAllJa: false,
    isAllNee: false,
    isAllUnknown: true,
    isIndeterminate: false,
  };
}

const { t } = useI18n();
const media = communicatieMedia;





const rowStatus = computed<CheckboxStatus>(() => {
  if (props.permissie === null) return emptyStatus();

  return calculateStatus(
    media.map((medium) => valueForMedium(medium.key))
  );
});

const allCheckboxStatus = computed<CheckboxStatus>(() => {
  return props.isTotal ? props.allStatus : rowStatus.value;
});

function calculateStatus(values: OptInKeuze[]): CheckboxStatus {
  const ja = values.filter((keuze) => keuze === OptInKeuze.Ja);
  const nee = values.filter((keuze) => keuze === OptInKeuze.Nee);
  const unknown = values.filter((keuze) => keuze === OptInKeuze.Onbekend);

  const isAllJa = ja.length === values.length;
  const isAllNee = nee.length === values.length;
  const isAllUnknown = unknown.length === values.length;
  const isIndeterminate = !isAllJa && !isAllNee && !isAllUnknown;

  return { isAllJa, isAllNee, isAllUnknown, isIndeterminate };
}

function valueForMedium(medium: CommunicatieMedium): OptInKeuze {
  if (props.permissie === null) return OptInKeuze.Onbekend;

  return get(props.permissie, medium, OptInKeuze.Onbekend) as OptInKeuze;
}

function mediumStatus(medium: CommunicatieMedium): CheckboxStatus {
  return props.mediumStatuses[medium] ?? emptyStatus();
}

function isSelected(medium: CommunicatieMedium): boolean {
  return valueForMedium(medium) === OptInKeuze.Ja;
}

function isUnknown(medium: CommunicatieMedium): boolean {
  return valueForMedium(medium) === OptInKeuze.Onbekend;
}

function toggle(field: CommunicatieMedium): void {
  emit("click", {
    permissie: props.permissieKey,
    field: field,
  });
}

function setAll(medium: CommunicatieMedium, value: boolean): void {
  emit("allclick", {
    medium: medium,
    value: value,
  });
}

function setAllRow(value: boolean): void {
  if (props.isTotal) {
    emit("allrowclick", { value });
    return;
  }

  emit("rowclick", {
    permissie: props.permissieKey,
    value,
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["permission-table", { header: __props.isTotal }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(__props.label), 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(VueCheckbox, {
          modelValue: _unref(allCheckboxStatus).isAllJa,
          indeterminate: _unref(allCheckboxStatus).isIndeterminate,
          unknown: _unref(allCheckboxStatus).isAllUnknown,
          label: _unref(t)('all'),
          "onUpdate:modelValue": setAllRow
        }, null, 8, ["modelValue", "indeterminate", "unknown", "label"])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(media), (medium) => {
        return (_openBlock(), _createElementBlock("div", {
          key: medium.key,
          class: _normalizeClass(["td choice", `choice-${medium.key}`])
        }, [
          (__props.isTotal)
            ? (_openBlock(), _createBlock(VueCheckbox, {
                key: 0,
                modelValue: mediumStatus(medium.key).isAllJa,
                indeterminate: mediumStatus(medium.key).isIndeterminate,
                unknown: mediumStatus(medium.key).isAllUnknown,
                label: _unref(t)(medium.labelKey),
                "onUpdate:modelValue": (value) => setAll(medium.key, value)
              }, null, 8, ["modelValue", "indeterminate", "unknown", "label", "onUpdate:modelValue"]))
            : (_openBlock(), _createBlock(VueCheckbox, {
                key: 1,
                modelValue: isSelected(medium.key),
                unknown: isUnknown(medium.key),
                label: _unref(t)(medium.labelKey),
                "onUpdate:modelValue": () => toggle(medium.key)
              }, null, 8, ["modelValue", "unknown", "label", "onUpdate:modelValue"]))
        ], 2))
      }), 128))
    ])
  ], 2))
}
}

})